import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { useForm } from "react-hook-form";

import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import { CancelButton, SaveButton } from "../../../common/Button";
import { Container, Row, Col, Form } from "react-bootstrap";

const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5 MB

// Returns an error message when the chosen file is not an acceptable image
const validateImage = (files) => {
  const file = files?.[0];
  if (!file) return true;

  if (!/\.(jpe?g|png|webp)$/i.test(file.name || "")) {
    return "Image must be a JPG, PNG or WEBP file";
  }
  if (file.size > MAX_IMAGE_SIZE) return "Image must be 5 MB or smaller";
  return true;
};

const previewStyle = {
  width: "100%",
  height: "150px",
  objectFit: "cover",
  borderRadius: "8px",
};

const EditOffCanvance = (props) => {
  const { postData, getData, IMG_URL } = useContext(Context);

  const id = props.show;

  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [oldImage, setOldImage] = useState(null);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const imageFile = watch("image");

  const GetEditData = async () => {
    const response = await getData(`/masters/strategy/${id}`);
    const data = response?.data;

    reset({
      title: data?.title,
      description: data?.description,
      win_ratio: data?.win_ratio,
    });
    setOldImage(data?.image);
  };

  useEffect(() => {
    if (id) GetEditData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("title", data.title);
      formData.append("description", data.description);
      formData.append("win_ratio", data.win_ratio);
      // Only send an image when a new one was chosen
      if (data.image?.[0]) {
        formData.append("image", data.image[0]);
      }

      const response = await postData(`/masters/strategy/${id}`, formData, true);

      setShowModal({ code: response.code, message: response.message });

      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement="end"
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Edit Strategy</Card.Title>
              <hr />

              <Container>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col lg={8} md={10} className="mx-auto Add-content">
                      {/* Title */}
                      <Row className="mt-4">
                        <Form.Label column sm={3}>
                          Title
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            placeholder="Title"
                            {...register("title", {
                              required: "Title is required",
                            })}
                          />
                          {errors.title && (
                            <span className="text-danger">
                              {errors.title.message}
                            </span>
                          )}
                        </Col>
                      </Row>

                      {/* Description */}
                      <Row className="mt-4">
                        <Form.Label column sm={3}>
                          Description
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            as="textarea"
                            rows={5}
                            placeholder="Description"
                            {...register("description", {
                              required: "Description is required",
                            })}
                          />
                          {errors.description && (
                            <span className="text-danger">
                              {errors.description.message}
                            </span>
                          )}
                        </Col>
                      </Row>

                      {/* Win ratio */}
                      <Row className="mt-4">
                        <Form.Label column sm={3}>
                          Win Ratio (%)
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="number"
                            step="0.01"
                            placeholder="Win Ratio"
                            {...register("win_ratio", {
                              required: "Win ratio is required",
                              min: { value: 0, message: "Minimum is 0" },
                              max: { value: 100, message: "Maximum is 100" },
                            })}
                          />
                          {errors.win_ratio && (
                            <span className="text-danger">
                              {errors.win_ratio.message}
                            </span>
                          )}
                        </Col>
                      </Row>

                      {/* Image */}
                      <Row className="mt-4">
                        <Form.Label column sm={3}>
                          Image
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="file"
                            accept="image/jpeg,image/png,image/webp"
                            {...register("image", { validate: validateImage })}
                          />
                          {errors.image && (
                            <span className="text-danger">
                              {errors.image.message}
                            </span>
                          )}

                          {imageFile?.length > 0 ? (
                            <div className="image-preview-container">
                              <img
                                src={URL.createObjectURL(imageFile[0])}
                                alt="Preview"
                                className="image-preview"
                                style={previewStyle}
                              />
                            </div>
                          ) : (
                            oldImage && (
                              <div className="image-preview-container">
                                <img
                                  src={IMG_URL + oldImage}
                                  alt="Preview"
                                  className="image-preview"
                                  style={previewStyle}
                                />
                              </div>
                            )
                          )}
                        </Col>
                      </Row>

                      {/* Buttons */}
                      <Row className="mt-5 pb-3">
                        <div className="d-flex justify-content-center">
                          <Link>
                            <CancelButton
                              name="cancel"
                              handleClose={props.handleClose}
                            />
                          </Link>

                          <SaveButton name="save" type="submit" />
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={!!showModal.code}
      />
    </>
  );
};

export default EditOffCanvance;
